import { useState } from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import {
  LayoutDashboard,
  Users,
  UserCircle,
  Building2,
  Kanban,
  Mail,
  Phone,
  FileText,
  FileSignature,
  BarChart3,
  Bell,
  Settings,
  Package,
  MessageSquareWarning,
  UserPlus,
  Brain,
} from "lucide-react";
import aiveliqLogo from "@/assets/aiveliq360-logo.png";

const navigation = [
  { name: "Dashboard", href: "/app", icon: LayoutDashboard },
  { name: "Leads", href: "/app/leads", icon: Users },
  { name: "Contacts", href: "/app/contacts", icon: UserCircle },
  { name: "Accounts", href: "/app/accounts", icon: Building2 },
  { name: "Deals", href: "/app/deals", icon: Kanban },
  { name: "Products", href: "/app/products", icon: Package },
  { name: "Outreach", href: "/app/outreach", icon: Mail },
  { name: "AI Assist", href: "/app/calls", icon: Phone },
  { name: "Proposals", href: "/app/proposals", icon: FileText },
  { name: "Contracts", href: "/app/contracts", icon: FileSignature },
  { name: "Objections", href: "/app/objections", icon: MessageSquareWarning },
  { name: "Onboarding", href: "/app/customer-onboarding", icon: UserPlus },
  { name: "AI Insights", href: "/app/ai-insights", icon: Brain },
  { name: "Analytics", href: "/app/analytics", icon: BarChart3 },
  { name: "Notifications", href: "/app/notifications", icon: Bell },
];

const bottomNav = [
  { name: "Settings", href: "/app/settings", icon: Settings },
];

export function MobileSidebar() {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0 w-64 bg-sidebar border-sidebar-border">
        <div className="flex h-full flex-col">
          {/* Logo */}
          <div className="flex h-16 items-center px-4 border-b border-sidebar-border">
            <img 
              src={aiveliqLogo} 
              alt="Aiveliq360" 
              className="h-10 object-contain" 
            />
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                end={item.href === "/app"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200",
                    isActive
                      ? "bg-sidebar-accent text-sidebar-accent-foreground ai-glow-subtle"
                      : "text-sidebar-foreground hover:bg-sidebar-accent/50 hover:text-sidebar-accent-foreground"
                  )
                }
              >
                <item.icon className="h-5 w-5 shrink-0" />
                <span>{item.name}</span>
              </NavLink>
            ))}
          </nav>

          {/* Bottom Navigation */}
          <div className="px-3 py-4 border-t border-sidebar-border">
            {bottomNav.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200",
                    isActive
                      ? "bg-sidebar-accent text-sidebar-accent-foreground"
                      : "text-sidebar-foreground hover:bg-sidebar-accent/50 hover:text-sidebar-accent-foreground"
                  )
                }
              >
                <item.icon className="h-5 w-5 shrink-0" />
                <span>{item.name}</span>
              </NavLink>
            ))}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
